import MyPathMilestoneTracker from './MyPathMilestoneTracker';

export default MyPathMilestoneTracker;
